import {
  Text,
  Box,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
} from '@chakra-ui/react';

import {
  IconAlertCircle,
} from '../../../../../styles/icons';
import {
  profileAccordionButton,
  profileAccordionPanel,
} from '../../../../utilities/render-helpers/renderPractitionerProfile';
import ProfileContactForm from '../common-forms/ProfileContactForm';
import { useState } from 'react';

const EditSectionContact = ({ profile }) => {
  const [saveProfile, setSaveProfile] = useState(false);
  // Render
  return (
    <AccordionItem>
      <h2>
        <AccordionButton _expanded={profileAccordionButton}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flex="1"
            //width="100%"
            textAlign="left"
          >
            <Box>
              <Text>Contact details</Text>
              {profile.pronoun && profile.pronoun[0] && (
                <Text textStyle="footer2" color="brand.200" noOfLines={1} maxWidth="300px">
                  Pronouns: {profile.pronoun[0].label}
                </Text>
              )}
              {profile.contactEmail && (
                <Text textStyle="footer2" color="brand.200" noOfLines={1} maxWidth="300px">
                  Email: {profile.contactEmail}
                </Text>
              )}
              {profile.practiceNumber && (
                <Text textStyle="footer2" color="brand.200" noOfLines={1} maxWidth="300px">
                  Contact number: {profile.practiceNumber}
                </Text>
              )}
              {profile.contactAddress && profile.contactAddress.address && (
                <Text textStyle="footer2" color="brand.200" noOfLines={1} maxWidth="350px">
                  Contact address: {profile.contactAddress.address}, {profile.contactAddress.city}, {profile.contactAddress.postcode}
                </Text>
              )}
            </Box>
            {profile.contactEmail
              && profile.practiceNumber
              && profile.contactAddress && profile.contactAddress.address ? (
              <Text padding="8px" textStyle="body2" color="green">
                Complete
              </Text>
            ) : (
              <Box display="flex" alignItems="center" padding="8px">
                <IconAlertCircle size="20px" color="tomato" />
                <Text textStyle="body2" paddingLeft="8px">
                  Incomplete
                </Text>
              </Box>
            )}
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel sx={profileAccordionPanel}>
        <ProfileContactForm
          setEditing={true}
          profile={profile}
          saveProfile={saveProfile}
          setSaveProfile={setSaveProfile}
          resetSaveIndicator={(action) => {
            setSaveProfile(action);
          }}
        />
      </AccordionPanel>
    </AccordionItem>
  );
};

export default EditSectionContact;
